import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

// Employee Expense vouchers: AccessProvisioning.nonProjectExpense (UI only; backend enforces)
const ExpenseEmployeeRoute = ({ children }) => {
  const { user } = useAuth();
  if (!user || user.access === undefined) return <div>Loading...</div>;
  return user.access?.nonProjectExpense === true
    ? children
    : <Navigate to={user.primaryRole === 'admin' ? '/admin/dashboard' : '/dashboard'} replace />;
};

export default ExpenseEmployeeRoute;
